import React from 'react';

import { useAuth } from '../../hooks/auth';
import { isFeatureGranted } from '../../utils/isFeatureGranted';
import { Icon } from '../Icon';
import { colors } from '../../styles/tokens';
import { Content, LockOverlay, Wrapper } from './styles';

interface FeatureGateProps {
  requiredFeature: string;
  message?: string;
}

// Padrão pra CONTEÚDO de um módulo indisponível pra essa academia -- ao
// contrário de uma página inteira (ver LockedFeaturePage, usado pelo
// AuthRoute) ou do menu (ElementMenu, que só mostra o cadeado), aqui
// o título de quem usa fica de fora (renderizado pelo caller, acima
// deste componente) e só o conteúdo em si borra, com o cadeado por
// cima -- é sobre o que a academia contratou, não sobre quem está
// logado, então não faz sentido só sumir ou esconder o módulo inteiro.
// Mensagem genérica de propósito -- não fala em "plano": o que libera
// pode ser upgrade, mas também addon concedido pela plataforma.
const FeatureGate: React.FC<FeatureGateProps> = ({
  requiredFeature,
  message = 'Não disponível para esta academia',
  children,
}) => {
  const { user } = useAuth();

  if (isFeatureGranted(user?.features?.[requiredFeature])) {
    return <>{children}</>;
  }

  return (
    <Wrapper>
      <Content>{children}</Content>
      <LockOverlay>
        <Icon name="lock" size={28} color={colors.onSurfaceVariant} />
        <span>{message}</span>
      </LockOverlay>
    </Wrapper>
  );
};

export { FeatureGate };
